export { default } from './SummaryTable';
export * from './SummaryTable.types';
export * from './SummaryTable.mock';
